import _ from 'lodash'
import { fetchTagList } from '@/api/tag/list'
import { fetchResTag } from '@/api/res_store/tag'
import { changeFullShaped } from '@/utils'

const tags = {
  state: {
    basePackageTagList: [],
    resourceTagList: {}
  },

  mutations: {
    SET_BASE_PACKAGE_TAG_LIST: (state, tagList = []) => {
      state.basePackageTagList = tagList
    },
    SET_RES_TAG_LIST: (state, { tagType, tagList = [] }) => {
      state.resourceTagList[tagType] = tagList
    }
  },

  actions: {
    GetBasePackageTagList({ commit, state }) {
      return new Promise((resolve, reject) => {
        fetchTagList({ type_ids: '13' }).then(res => {
          const tagList = _.get(res, 'data.data.list')
          commit('SET_BASE_PACKAGE_TAG_LIST', tagList)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    GetResTagList(
      { commit, state },
      { params }
    ) {
      return new Promise((resolve, reject) => {
        const innerParams = params || {}
        const dataConversion = (data, key) => {
          const cloneData = _.cloneDeep(data)
          const subKey = key || 'sub_tags'

          const changeKey = data => {
            data.forEach((item, i) => {
              data[i]['label'] = changeFullShaped(data[i]['name'])
              data[i]['value'] = data[i]['id']
              delete data[i]['name']
              // 递归
              if (data[i][subKey] && data[i][subKey].length > 0) {
                data[i]['children'] = data[i][subKey]
                delete data[i][subKey]
                changeKey(data[i].children)
              }
            })
          }

          changeKey(cloneData)

          return cloneData
        }
        fetchResTag(innerParams).then(res => {
          let tagList = _.get(res, 'data.data.tag.sub_tags')
          const tagType = _.get(res, 'data.data.tag.type')
          if (tagList && tagList.length > 0) {
            tagList = dataConversion(tagList)
          }
          commit('SET_RES_TAG_LIST', {
            tagType,
            tagList
          })
          resolve(tagList)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}

export default tags
